module.exports = __webpack_public_path__ + "static/img/brandlogo.e09f627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brandlogo.png
// module id = wT77
// module chunks = 0